import PorcentageGraph from "./PorcentageGraph";
export default PorcentageGraph;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/ourPartners/components/porcentageGraph/index.js